// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3vxuI","label":"Radio_label__5Em00","checkMark":"Radio_checkMark__eg-2j","disabled":"Radio_disabled__myT9y"};